module.exports = __webpack_public_path__ + "static/europodroze-0d8297d255541b291afee51bdc39f785.png";